import { cloneObject } from '../../../../utils';
import { getFields } from '../../../../utils/defaultFields';

const fields = [
    'cellphone',
    'email',
    'pregnant',
    'newborn',
    'requestType',
    'areaRegion',
    'surgeryDate',
    'exameLocation',
    'note',
    'fullName',
    'cardNumber',
];

const schema = {
    ...cloneObject(getFields(fields)),
    exameLocation: {
        ...cloneObject(getFields(['exameLocation'])).exameLocation,
        help: 'Nome do local completo da clínica ou laboratório / hospital onde será realizado o exame ou procedimento cirúrgico.',
    },
    note: {
        ...cloneObject(getFields(['note'])).note,
        help: 'Região que reside (exemplo: zona sul ou leste) e o nome do local em que deseja realizar o procedimento (se souber) e qualquer outro dado que considere relevante (peso, altura, mobilidade reduzida etc.)',
        value: '',
    },
};

schema.documents = [];

export default schema;
